var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picturePreview"},[_c('el-carousel',{attrs:{"interval":5000,"arrow":"always","autoplay":false}},_vm._l((_vm.imgSrc),function(item,index){return _c('el-carousel-item',{key:index},[_c('iframe',{attrs:{"src":item,"frameborder":"0"}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }